import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@osteopro/ui';
import { themes, type Theme } from '@osteopro/shared';
import { Monitor, Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../lib/theme-provider.js';

const ICONS: Record<Theme, typeof Sun> = { light: Sun, dark: Moon, system: Monitor };

/** Sélecteur de thème de l'en-tête, identique à la V1 (clair / sombre / système). */
export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" data-testid="button-theme-toggle">
          <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
          <span className="sr-only">{t('shell:theme.toggle')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {themes.map((value) => {
          const Icon = ICONS[value];
          return (
            <DropdownMenuItem
              key={value}
              className="gap-2"
              onClick={() => {
                setTheme(value);
              }}
              data-testid={`theme-${value}`}
            >
              <Icon className="h-4 w-4" />
              <div className="flex flex-col">
                <span>{t(`shell:theme.${value}`)}</span>
                <span className="text-xs text-muted-foreground">
                  {t(`shell:theme.${value}_hint`)}
                </span>
              </div>
              {theme === value && <span className="ml-auto h-2 w-2 rounded-full bg-primary" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
